const queryString = require('query-string');

const SEED_CHARS = '2346789BCDFGHJKMQRTVWXY';

export const getSeed = () => {
  const { hash } = window.location;
  const { seed } = queryString.parse(hash);
  if (seed) {
    return seed;
  }

  let result = '';
  for (let i = 5; i > 0; i -= 1) {
    result += SEED_CHARS[Math.floor(Math.random() * SEED_CHARS.length)];
  }
  return result;
};
